const reach = [
  'channelIds',
  'placement',
  'screenIds',
  'includeDemographicalBreakdown',
  'includeHourlyBreakdown',
];

const exposures = [
  'clientIds',
  'bookingNumbers',
  'channelIds',
  'screenIds',
  'bookingTypes',
  'placement',
  'mediaFiles',
  'includePrimaryOrSecoundaryExposureBreakdown',
  'includeShareOfVoice',
  'includeExtendedStatistics',
  'includeReach',
  'includeDemographicalBreakdown',
  'includeAdvertisingStatistics',
];

const peopleCounter = [
  'channelIds',
  'placement',
  'tracking',
  'screenIds',
  'includeDemographicalBreakdown',
  'includeHourlyBreakdown',
];

const poi = [
  'poiCategoryName',
  'poiName',
  'channelIds',
  'placement',
  'tracking',
  'screenIds',
  'includePOIAdministrativeDetails',
  'includeSMSNotifications',
];

const filterConfig = { reach, exposures, peopleCounter, poi };
export default filterConfig;